import React, { useEffect, useState } from 'react';
import { MoveRight, CheckCheck, Ban, Truck, Clock } from 'lucide-react';

const OrderSummaryCards = ({ data }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getGridColumns = () => {
        if (windowWidth < 640) {
            return 'repeat(2, 1fr)'; // 2 columns on mobile
        } else if (windowWidth < 1024) {
            return 'repeat(3, 1fr)'; // 3 columns on tablet
        } else {
            return 'repeat(5, 1fr)'; // 5 columns on desktop
        }
    };

    const getCardStyles = (index) => {
        const isLastOddCard = windowWidth < 640 && index === 4; // Last card (index 4) when in 2-column layout
        const baseStyles = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: windowWidth < 640 ? '8px 12px' : '12px 16px',
            borderRadius: '10px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            boxSizing: 'border-box',
            borderLeft: windowWidth < 640 ? '2px solid' : '3px solid',
            cursor: 'pointer',
            width: '100%',
            gridColumn: isLastOddCard ? 'span 2' : 'auto', // Full width for last card on mobile
            minHeight: windowWidth < 640 ? '60px' : '80px', // Reduced height
        };

        return baseStyles;
    };

    const iconWrapper = {
        padding: windowWidth < 640 ? '6px' : '8px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const textStyle = {
        fontSize: windowWidth < 640 ? '10px' : windowWidth < 1024 ? '12px' : '13px',
        color: '#4B5563',
        fontWeight: 600,
        marginBottom: '2px',
        textTransform: 'uppercase',
    };

    const numberStyle = {
        fontSize: windowWidth < 640 ? '16px' : windowWidth < 1024 ? '20px' : '22px',
        fontWeight: 700,
    };

    const cards = [
        {
            label: 'Placed',
            value: data.placed || 0,
            bg: '#E0F2FE',
            border: '#0284C7',
            icon: <Clock color="#0369A1" size={windowWidth < 640 ? 16 : 20} />,
            iconBg: '#BAE6FD',
            textColor: '#0369A1',
        },
        {
            label: 'Ongoing',
            value: data.ongoing || 0,
            bg: '#DBEAFE',
            border: '#3B82F6',
            icon: <MoveRight color="#2563EB" size={windowWidth < 640 ? 16 : 20} />,
            iconBg: '#BFDBFE',
            textColor: '#1D4ED8',
        },
        {
            label: 'Out for Delivery',
            value: data.out_for_delivery || 0,
            bg: '#FEF3C7',
            border: '#F59E0B',
            icon: <Truck color="#D97706" size={windowWidth < 640 ? 16 : 20} />,
            iconBg: '#FDE68A',
            textColor: '#D97706',
        },
        {
            label: 'Cancelled',
            value: data.cancelled || 0,
            bg: '#FEE2E2',
            border: '#EF4444',
            icon: <Ban color="#B91C1C" size={windowWidth < 640 ? 16 : 20} />,
            iconBg: '#FCA5A5',
            textColor: '#B91C1C',
        },
        {
            label: 'Completed',
            value: data.completed || 0,
            bg: '#DCFCE7',
            border: '#22C55E',
            icon: <CheckCheck color="#15803D" size={windowWidth < 640 ? 16 : 20} />,
            iconBg: '#BBF7D0',
            textColor: '#15803D',
        },
    ];

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: getGridColumns(),
                gap: windowWidth < 640 ? '8px' : '12px',
                width: '100%',
                marginBottom: '12px',
                // padding: windowWidth < 640 ? '0 8px' : '0 12px',
            }}
        >
            {cards.map((card, index) => (
                <div
                    key={index}
                    style={{
                        ...getCardStyles(index),
                        backgroundColor: card.bg,
                        borderLeft: `${windowWidth < 640 ? '2px' : '3px'} solid ${card.border}`,
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
                    }}
                >
                    <div>
                        <div style={textStyle}>{card.label}</div>
                        <div style={{ ...numberStyle, color: card.textColor }}>{card.value}</div>
                    </div>
                    <div style={{ ...iconWrapper, backgroundColor: card.iconBg }}>{card.icon}</div>
                </div>
            ))}
        </div>
    );
};

export default OrderSummaryCards;